import * as Yup from 'yup';

export const emailTemplateSchema = Yup.object().shape({
  templateName: Yup.string().required('Nome é obrigatório.'),
  subject: Yup.string().required('Assunto é obrigatório.'),
});